import styled from 'styled-components';
import { useStore } from '../stores/store';
import { useModal } from './useModal';

// Se muestra UNA vez a los usuarios nuevos, justo después del aviso de bienvenida:
// presenta las features de la app (mismo contenido que "Acerca de" en Preferencias).
export function Intro() {
  const introPending = useStore((s) => s.introPending);
  const setIntroPending = useStore((s) => s.setIntroPending);
  // Antes del early-return: las reglas de hooks piden llamarlo incondicionalmente.
  // `active`: el componente vive montado y "abre" cuando introPending pasa a true.
  const panelRef = useModal(() => setIntroPending(false), introPending);
  if (!introPending) return null;

  return (
    <Overlay>
      <Card ref={panelRef} role="dialog" aria-modal="true" aria-label="Qué vas a encontrar en la app" tabIndex={-1} onClick={(e) => e.stopPropagation()}>
        <h3>Esto es lo que vas a encontrar 👇</h3>
        <ul>
          <li><b>🔮 El Oráculo</b> — pronóstico de cada partido: favorito, probabilidad 1-X-2 y los factores que pesan. ¡Entrenalo a tu gusto!</li>
          <li><b>🟢 En vivo</b> — marcador y minuto al instante, con goleadores y pizarra a pantalla completa.</li>
          <li><b>📊 Ficha del partido</b> — estadísticas, alineaciones, eventos, árbitro y clima de la sede.</li>
          <li><b>📅 Partidos y Hoy</b> — calendario completo, lo que se juega ahora y los últimos resultados.</li>
          <li><b>🧮 Zonas y Llave</b> — tablas de los 12 grupos y simulador de la llave.</li>
          <li><b>📚 Histórico</b> — todos los Mundiales 1930-2022.</li>
        </ul>
        <p className="foot">Podés volver a verlo en <b>Menú → Acerca de</b>.</p>
        <button onClick={() => setIntroPending(false)}>¡A vivir el Mundial! ⚽</button>
      </Card>
    </Overlay>
  );
}

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  background: rgba(2, 6, 12, 0.7);
  backdrop-filter: blur(3px);
`;

const Card = styled.div`
  width: 100%;
  max-width: 400px;
  max-height: 92vh;
  overflow-y: auto;
  background: linear-gradient(165deg, ${({ theme }) => theme.colors.accentDark}, ${({ theme }) => theme.colors.surface} 60%);
  border: 1px solid ${({ theme }) => theme.colors.borderStrong};
  border-radius: ${({ theme }) => theme.radius};
  padding: 22px 18px 18px;
  color: ${({ theme }) => theme.colors.text};
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.55);

  h3 { margin: 0 0 14px; font-size: 1.25rem; }
  ul {
    list-style: none;
    margin: 0 0 14px;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 11px;
    font-size: 0.92rem;
    line-height: 1.4;
  }
  li b { color: ${({ theme }) => theme.colors.text}; }
  .foot { font-size: 0.79rem; color: ${({ theme }) => theme.colors.textMuted}; margin: 0 0 14px; text-align: center; }
  button {
    width: 100%;
    background: ${({ theme }) => theme.colors.accent};
    color: ${({ theme }) => theme.colors.accentText};
    border: none;
    border-radius: 999px;
    padding: 13px;
    font-weight: 800;
    font-size: 1rem;
  }
`;
